<template>
    <div class="transfer-plan" style="position: relative">
        <div v-if="type == 'query'" class="button-container">
            <div class="left-button">
                <Button
                    v-if="
                        (formData.status == 0 || formData.status == 6) &&
                        !isAdminFrom &&
                        handleAuth('fbb.transferplan.edit')
                    "
                    type="primary"
                    @click="handleOperate('submit')"
                    >提交审核</Button
                >
                <Button
                    v-if="
                        formData.status == 5 &&
                        isAdminFrom &&
                        handleAuth('fbb.transferplan.review')
                    "
                    type="primary"
                    @click="handleOperate('audit')"
                    >审核</Button
                >
                <Button
                    v-if="
                        formData.status == 5 &&
                        !isAdminFrom &&
                        handleAuth('fbb.transferplan.edit')
                    "
                    type="warning"
                    @click="handleOperate('cancelSubmit')"
                    >撤销审核</Button
                >
                <Button
                    type="success"
                    v-if="
                        formData.status == 20 &&
                        isAdminFrom &&
                        handleAuth('fbb.transferplan.complete')
                    "
                    @click="handleOperate('inboundComplete')"
                    >入库完成</Button
                >
                <Button
                    type="success"
                    v-if="
                        (formData.status == 25 || formData.status == 30) &&
                        isAdminFrom
                    "
                    @click="
                        handleOperate('outboundComplete') &&
                            handleAuth('fbb.transferplan.complete')
                    "
                    >出库完成</Button
                >
                <Button
                    v-if="
                        formData.status == 10 &&
                        handleAuth('fbb.transferplan.edit')
                    "
                    type="success"
                    @click="handleOperate('confirmDelivery')"
                    >确认发货</Button
                >
                <Button
                    v-if="
                        formData.status <= 15 &&
                        handleAuth('fbb.transferplan.edit')
                    "
                    type="default"
                    @click="handleOperate('cancel')"
                    >取消</Button
                >
                <Button
                    v-if="formData.errorStatus < 99999"
                    type="info"
                    @click="handleOperate('dealAgain')"
                    >重处理</Button
                >
                <Button
                    v-if="formData.errorStatus < 99999"
                    type="warning"
                    @click="handleOperate('ignoreError')"
                    >忽略异常
                </Button>
                <Button
                    v-if="formData.status == 15"
                    type="primary"
                    @click="handleOperate('pushWarehouse')"
                    >重推仓库</Button
                >
            </div>
            <div class="right-button">
                <Button type="default" @click="cancel">返回</Button>
            </div>
        </div>
        <compWrapper title="基础信息" theme="primary">
            <compFormQuery
                v-if="type == 'query'"
                class="margin-top-15 margin-right-15"
                :formdata="getBase"
                :value="formData"
                :labelWidth="120"
                placeholder="--"
            ></compFormQuery>
            <compFormEdit
                v-else
                class="margin-top-15 margin-right-15"
                ref="editform"
                :formdata="getBase"
                v-model="formData"
                :labelWidth="120"
            />
            <template v-if="type != 'query'" slot="footer">
                <vButton
                    class="margin-right-20"
                    theme="primary"
                    @click="submit(0)"
                    >{{
                        $t("fbb.inbound.save_draft", {
                            defaultValue: "保存为草稿",
                        })
                    }}</vButton
                >
                <vButton
                    class="margin-right-20"
                    theme="success"
                    @click="submit(1)"
                    >{{
                        $t("fbb.inbound.submit_audit", {
                            defaultValue: "提交审核",
                        })
                    }}</vButton
                >
                <vButton class="margin-right-20" @click="cancel">{{
                    $t("global.common.operate_cancel", { defaultValue: "取消" })
                }}</vButton>
            </template>
        </compWrapper>
        <compWrapper
            v-if="type == 'query' && formData.status >= 15"
            title="发运信息"
            theme="info"
        >
            <compFormQuery
                class="margin-top-15 margin-right-15"
                :formdata="getDelivery"
                :value="formData"
                :labelWidth="120"
                placeholder="--"
            ></compFormQuery>
        </compWrapper>
        <compWrapper title="产品信息" theme="success">
            <div
                v-if="type != 'query'"
                class="margin-top-15"
                style="display: flex"
            >
                <Form
                    ref="productForm"
                    :labelWidth="80"
                    :model="productData"
                    inline
                >
                    <FormItem
                        label="SKU"
                        prop="sku"
                        style="margin-bottom: 15px"
                        :rules="required"
                    >
                        <!-- <compErpSkuInput v-model="productData.sku"></compErpSkuInput> -->
                        <Input v-model="productData.sku" readonly>
                            <Icon
                                style="cursor: pointer"
                                type="ios-search"
                                slot="suffix"
                                @click="handleSKU"
                            ></Icon>
                        </Input>
                    </FormItem>
                    <FormItem
                        class="margin-left-20"
                        :labelWidth="100"
                        label="其他识别码"
                        prop="alias"
                        :rules="required"
                    >
                        <Input
                            style="width: 285px"
                            v-model="productData.alias"
                            placeholder="填写seller SKU/FNSKU等识别码，多个用逗号隔开"
                        ></Input>
                    </FormItem>
                    <FormItem
                        class="margin-left-20"
                        label="数量"
                        prop="qty"
                        :rules="required"
                        style="margin-bottom: 15px"
                    >
                        <InputNumber
                            class="width-100per"
                            v-model="productData.qty"
                            :min="1"
                            :precision="0"
                        ></InputNumber>
                    </FormItem>
                </Form>
                <div class="margin-left-50">
                    <Button type="primary" @click="addOne">添加</Button>
                    <Button
                        class="margin-left-15"
                        type="info"
                        @click="importItem"
                        >导入</Button
                    >
                </div>
            </div>
            <div v-if="type != 'query'" class="margin-left-40 margin-top-10">
                <Button type="default" @click="deleteOne">删除</Button>
                <Button class="margin-left-15" type="default" @click="clearAll"
                    >清空</Button
                >
            </div>
            <div
                style="
                    padding: 15px 40px;
                    padding-bottom: 0;
                    display: flex;
                    justify-content: space-between;
                "
            >
                <div>
                    产品总数量:
                    <span class="font-bold">{{ totalData.planQty }}</span>
                </div>
                <div>
                    产品总体积(CBM):
                    <span class="font-bold">{{ totalData.totalVolume }}</span>
                </div>
                <div>
                    产品总重量(kg):
                    <span class="font-bold">{{ totalData.totalWeight }}</span>
                </div>
            </div>
            <div style="padding: 15px; padding-top: 5px">
                <Table
                    size="small"
                    :columns="columns"
                    :data="productList"
                    @on-selection-change="handleColumnsSelect"
                ></Table>
            </div>
        </compWrapper>
        <compWrapper title="附件信息" theme="primary">
            <div style="padding: 15px">
                <div
                    v-if="!formData.status || formData.status <= 15 || formData.status == 25"
                    class="margin-bottom-15"
                >
                    <Button
                        class="margin-right-15"
                        type="primary"
                        @click="addAttach"
                        >添加</Button
                    >
                    <Button
                        class="margin-right-15"
                        type="default"
                        @click="deleteAttach"
                        >删除</Button
                    >
                    <Button
                        v-if="formData.status == 15"
                        type="info"
                        @click="pushAgain"
                        >附件重推</Button
                    >
                </div>
                <Table
                    size="small"
                    :columns="attachColumns"
                    :data="attachList"
                    @on-selection-change="handleAttachSelect"
                ></Table>
            </div>
        </compWrapper>
        <compWrapper
            v-if="type == 'query'"
            :title="
                $t('global.common.operate_history', {
                    defaultValue: '操作历史',
                })
            "
            theme="gray"
        >
            <compLog
                class="margin-layout"
                :data="logList"
                :columns="logcolumn"
            ></compLog>
        </compWrapper>
        <compModal v-model="operate.show" v-bind="operate">
            <component
                :is="operate.component"
                v-bind="operate.props"
                v-on="operate.on"
            ></component>
        </compModal>
        <Spin v-if="loading" fix></Spin>
    </div>
</template>

<script>
import compSku from "./sku";
import compAttach from "./alert/attach";
import mixin from "./mixin";
import ajaxmixin from "./ajaxmixin";
import compDelivery from "./alert/delivery";
import {
    HttpGetDetail,
    HttpDelAttach,
    HttpFindSKU,
    HttpUpdatePlan,
    HttpSubmitUpdatePlan,
    HttpTransferPlanSubmit,
    HttpTransferPlanCancelSubmit,
    HttpTransferPlanCancel,
    HttpTransferPlanDealAgain,
    HttpTransferPlanRepushAttach,
    HttpInboundComplete,
    HttpOutboundComplete,
    HttpTransferPlanAudit,
    HttpWarehouseAddress,
    HttpTransferPlanAddProduct,
    HttpTransferPlanClear,
    HttpTransferPlanDeletById,
    HttpTransferPlanIgonreError,
    HttpTransferPushWarehouse
} from "@/service/transferplan";
import { mapState, mapGetters } from "vuex";
export default {
    props: ["activeid", "querytype", "isAdmin"],
    mixins: [mixin, ajaxmixin],
    components: {
        compSku,
        compAttach,
        compDelivery,
    },
    data() {
        return {
            type: this.querytype ? this.querytype : this.$route.params.type,
            id: this.activeid ? this.activeid : this.$route.query.id,
            isAdminFrom: this.isAdmin
                ? this.isAdmin
                : this.$route.query.isAdmin,
            formData: {},
            productData: {
                qty: null,
            },
            totalData: {},
            productList: [],
            deliveryData: {},
            attachList: [],
            logList: [],
            selectedAttach: [],
            skuData: {},
            operate: {
                show: false,
            },
            isFirstGetData: true,
            loading: false,
        };
    },
    created() {
        if (this.type != "add") {
            this.getDetail();
        }
        if (this.isAdminFrom) {
            this.getMixinWarehouse(true);
        }
    },
    watch: {
        productList: {
            handler(productList) {
                if (this.type == "query") return;
                if (this.type == "edit" && this.isFirstGetData) return;
                this.handleTotal(productList);
            },
        },
        "formData.receiveCode": {
            handler(receiveCode) {
                if (!receiveCode) return;
                HttpWarehouseAddress({
                    code: receiveCode,
                }).then(
                    (res) => {
                        console.log("address", res);
                        this.$set(this.formData, "country", res.data.country);
                        this.$set(this.formData, "state", res.data.state);
                        this.$set(this.formData, "city", res.data.city);
                        this.$set(this.formData, "address", res.data.address);
                        this.$set(this.formData, "postal", res.data.postal);
                    },
                    (err) => {
                        this.$VMessage.error(err.message);
                    }
                );
            },
        },
    },
    computed: {
        ...mapGetters("dictionary", [
            "getProductList",
            "getCusproductList",
            "getSelfmanageorgList",
        ]),
        ...mapGetters("common", ["getCountryList"]),
        getBase() {
            return [
                {
                    label: "转运计划单号",
                    tag: "vInput",
                    key: "transitPlanOrderNo",
                    show: this.type != "add",
                    required: false,
                    render: (h) => {
                        let errorItem = this.getExceptionStatus.filter(
                            (item) => {
                                return item.value == this.formData.errorStatus;
                            }
                        )[0];

                        return (
                            <div>
                                <span>{this.formData.transitPlanOrderNo}</span>
                                <span
                                    class="margin-left-20 color-error"
                                    v-show={!!errorItem}
                                >
                                    {errorItem ? errorItem.label : ""}
                                </span>
                            </div>
                        );
                    },
                    query: true,
                },
                {
                    label: "状态",
                    tag: "vSelect",
                    key: "status",
                    options: this.getStatus,
                    show: this.type != "add",
                    required: false,
                    query: true,
                },
                {
                    label: "来源单号",
                    tag: "vInput",
                    key: "sourceNo",
                    query: this.type == "query",
                    required: false,
                },
                {
                    label: "转运仓库",
                    tag: "vSelect",
                    key: "orgWarehouseId",
                    options: this.mixinWarehouseList,
                    query: this.type == "query",
                    required: true,
                },
                {
                    label: "项目",
                    tag: "vSelect",
                    key: "lineId",
                    options: this.isAdminFrom
                        ? this.getCusproductList
                        : this.getProductList,
                    props: {
                        filterable: true,
                    },
                    query: this.type == "query",
                    required: true,
                },
                {
                    label: "发货方名称",
                    tag: "vInput",
                    key: "shipperName",
                    query: this.type == "query",
                    required: false,
                },
                {
                    label: "发货方地址",
                    tag: "vInput",
                    key: "shipperAddress",
                    query: this.type == "query",
                    required: false,
                },
                {
                    label: "Shipment ID",
                    tag: "vInput",
                    key: "shipmentId",
                    query: this.type == "query",
                    required: true,
                },
                {
                    label: "Reference ID",
                    tag: "vInput",
                    key: "referenceId",
                    query: this.type == "query",
                    required: true,
                },
                {
                    label: "目的地",
                    tag: "vSelect",
                    key: "receiveCode",
                    options: this.mixinDestinationList,
                    props: {
                        filterable: true
                    },
                    query: this.type == "query",
                    required: true,
                },
                {
                    label: "国家",
                    key: "country",
                    options: this.getCountryList,
                    query: this.type == "query",
                    props: {
                        filterable: true,
                    },
                    render: (h) => {
                        return (
                            <div class="font-bold">{this.formData.country}</div>
                        );
                    },
                    required: true,
                },
                {
                    label: "州",
                    tag: "vInput",
                    key: "state",
                    query: this.type == "query",
                    required: true,
                },
                {
                    label: "城市",
                    tag: "vInput",
                    key: "city",
                    query: this.type == "query",
                    required: true,
                },
                {
                    label: "邮编",
                    tag: "vInput",
                    key: "postal",
                    query: this.type == "query",
                    required: true,
                },
                {
                    label: "地址",
                    tag: "vInput",
                    key: "address",
                    query: this.type == "query",
                    required: true,
                },
                {
                    label: "期望到仓日期",
                    tag: "vDatepicker",
                    key: "expectArriveTime",
                    props: {
                        format: "yyyy-mm-dd",
                        type: "date",
                    },
                    query: this.type == "query",
                    required: true,
                },
                {
                    label: "目的地运输方式",
                    tag: "vSelect",
                    key: "shipType",
                    options: this.getShipType,
                    query: this.type == "query",
                    required: false,
                },
                {
                    label: "客户",
                    tag: "vSelect",
                    options: this.getSelfmanageorgList,
                    key: "organizationId",
                    query: true,
                    show: !!this.isAdminFrom,
                },
                {
                    label: "备注",
                    tag: "vTextarea",
                    key: "remark",
                    query: this.type == "query",
                    required: false,
                },
            ];
        },
        getDelivery() {
            return [
                {
                    label: "实际发运日期",
                    key: "actualShipDate",
                },
                {
                    label: "预计到仓日期",
                    key: "estimateArriveTime",
                },
                {
                    label: "物流单号",
                    key: "tmsNo",
                },
                {
                    label: "货物形态",
                    key: "goodsType",
                    tag: "vSelect",
                    options: this.getGoodsType,
                },
                {
                    label: "20GP集装箱数量",
                    key: "gpQuantity20",
                    show: this.formData.goodsType != 4,
                },
                {
                    label: "20GP集装箱号",
                    key: "gpCartonNo20",
                    show: this.formData.goodsType != 4,
                },
                {
                    label: "40GP集装箱数量",
                    key: "gpQuantity40",
                    show: this.formData.goodsType != 4,
                },
                {
                    label: "40GP集装箱号",
                    key: "gpCartonNo40",
                    show: this.formData.goodsType != 4,
                },
                {
                    label: "40HQ集装箱数量",
                    key: "hqQuantity40",
                    show: this.formData.goodsType != 4,
                },
                {
                    label: "40HQ集装箱号",
                    key: "hqCartonNo40",
                    show: this.formData.goodsType != 4,
                },
                {
                    label: "45HQ集装箱数量",
                    key: "hqQuantity45",
                    show: this.formData.goodsType != 4,
                },
                {
                    label: "45HQ集装箱号",
                    key: "hqCartonNo45",
                    show: this.formData.goodsType != 4,
                },
                {
                    label: "实际到仓日期",
                    key: "actualArriveWarehouseDate",
                    show: this.type == "query",
                },
            ];
        },
        columns() {
            let columns = [
                {
                    type: "selection",
                    align: "center",
                    width: 55,
                },
                {
                    type: "index",
                    title: "序号",
                    width: 70,
                },
                {
                    title: "SKU",
                    key: "sku",
                },
                {
                    title: "其他识别码",
                    key: "alias",
                },
                {
                    title: "产品名称",
                    key: "name",
                },
                {
                    title: "计划数",
                    key: "qty",
                },
                {
                    title: "已接收数",
                    key: "inboundQty",
                },
                {
                    title: "已出库数",
                    key: "outboundQty",
                },
                {
                    title: "长*宽*高(cm*cm*cm)",
                    render: (h, { row }) => {
                        return (
                            <div>
                                {row.length} * {row.width} * {row.height}
                            </div>
                        );
                    },
                },
                {
                    title: "重量(g)",
                    key: "weight",
                },
            ];
            if (this.type == "query") {
                columns.splice(0, 1);
            } else {
                columns.splice(6, 2);
            }
            return columns;
        },
        attachColumns() {
            let columns = [
                {
                    type: "selection",
                    width: 55,
                    align: "center",
                },
                {
                    title: "附件类型",
                    key: "attachType",
                },
                {
                    title: "附件名称",
                    key: "filename",
                    render: (h, { row }) => {
                        return (
                            <a href={row.fileurl} target="_blank">
                                {row.filename}
                            </a>
                        );
                    },
                },
                {
                    title: "创建时间",
                    key: "createdAt",
                },
            ];
            // if (this.formData.status > 15) {
            //     columns.splice(0, 1);
            // }
            return columns;
        },
        logcolumn() {
            return [
                {
                    title: this.$t("global.common.operator", {
                        defaultValue: "操作人",
                    }),
                    key: "updatedName",
                },
                {
                    title: this.$t("global.common.operate_type", {
                        defaultValue: "操作类型",
                    }),
                    key: "operateType",
                    render: (h, { row }) => {
                        let operateName = this.getOperateType.filter((item) => {
                            return row.operateType == item.value;
                        })[0];
                        return (
                            <div>{operateName ? operateName.label : "--"}</div>
                        );
                    },
                },
                {
                    title: "备注",
                    key: "remark",
                },
                {
                    title: this.$t("global.common.createdtime", {
                        defaultValue: "创建时间",
                    }),
                    key: "createdAt",
                },
            ];
        },
        required() {
            return [
                {
                    required: true,
                    message: "此项不能为空，请填写",
                },
            ];
        },
    },
    methods: {
        handleTotal(productList) {
            let volumn = 0,
                weight = 0,
                qty = 0;
            productList.map((item) => {
                volumn += parseFloat(item.cbmVolumn) * parseInt(item.qty);
                weight += parseFloat(item.kgWeight) * parseInt(item.qty);
                qty += parseInt(item.qty);
            });
            this.$set(this.totalData, "totalVolume", volumn.toFixed(4));
            this.$set(this.totalData, "totalWeight", weight.toFixed(4));
            this.$set(this.totalData, "planQty", qty);
        },
        async pushAgain() {
            this.loading = true;
            await HttpTransferPlanRepushAttach({
                id: this.id,
            }).then(
                (res) => {
                    this.$VMessage.success(res.message);
                },
                (err) => {
                    this.$VMessage.error(err.message);
                }
            );
            this.loading = false;
        },
        handleOperate(type) {
            let operate = {
                show: true,
                alert: "primary",
                width: 400,
                showDesc: false,
                showFooter: true,
                params: {
                    id: this.id,
                },
                callback: (res) => {
                    this.$VMessage.success(res.message);
                    this.getDetail();
                },
            };
            switch (type) {
                // 提交审核
                case "submit":
                    {
                        this.operate = {
                            ...operate,
                            title: "提交审核",
                            showDesc: true,
                            ajaxRequest: HttpTransferPlanSubmit,
                        };
                    }
                    break;
                // 撤销审核
                case "cancelSubmit":
                    {
                        this.operate = {
                            ...operate,
                            title: "撤销审核",
                            showDesc: true,
                            ajaxRequest: HttpTransferPlanCancelSubmit,
                        };
                    }
                    break;
                // 确认发货
                case "confirmDelivery":
                    {
                        this.operate = {
                            title: "确认发货",
                            show: true,
                            width: 1200,
                            props: {
                                activeid: [this.id],
                                isEdit: true,
                            },
                            showFooter: false,
                            component: "compDelivery",
                            on: {
                                "on-close": () => {
                                    this.operate = false;
                                },
                                "on-update": () => {
                                    this.getDetail();
                                    this.operate = false;
                                },
                            },
                        };
                    }
                    break;
                // 取消
                case "cancel":
                    {
                        this.operate = {
                            ...operate,
                            title: "取消",
                            alert: "warning",
                            formdata: [
                                {
                                    label: "取消原因",
                                    key: "remark",
                                    tag: "vTextarea",
                                    span: 24,
                                },
                            ],
                            ajaxRequest: HttpTransferPlanCancel,
                        };
                    }
                    break;
                // 重处理
                case "dealAgain":
                    {
                        this.operate = {
                            ...operate,
                            title: "异常重处理",
                            showDesc: true,
                            ajaxRequest: HttpTransferPlanDealAgain,
                        };
                    }
                    break;
                // 忽略异常
                case "ignoreError":
                    {
                        this.operate = {
                            ...operate,
                            title: "忽略异常",
                            showDesc: true,
                            ajaxRequest: HttpTransferPlanIgonreError,
                        };
                    }
                    break;
                // 重推仓库
                case "pushWarehouse":
                    {
                        this.operate = {
                            ...operate,
                            title: "重推仓库",
                            showDesc: true,
                            ajaxRequest: HttpTransferPushWarehouse
                        }
                    }
                    break;
                case "inboundComplete":
                    this.operate = {
                        ...operate,
                        title: "入库完成",
                        alert: "primary",
                        ajaxRequest: HttpInboundComplete,
                        params: {
                            id: this.id,
                        },
                        formdata: [
                            {
                                label: "备注",
                                key: "remark",
                                tag: "vTextarea",
                                labelWidth: 70,
                                span: 22,
                                required: false,
                            },
                        ],
                    };
                    break;
                case "outboundComplete":
                    this.operate = {
                        ...operate,
                        title: "出库完成",
                        ajaxRequest: HttpOutboundComplete,
                        params: {
                            id: this.id,
                        },
                        formdata: [
                            {
                                label: "备注",
                                key: "remark",
                                tag: "vTextarea",
                                labelWidth: 70,
                                span: 22,
                                required: false,
                            },
                        ],
                    };
                    break;
                case "audit":
                    this.operate = {
                        ...operate,
                        title: "审核",
                        alert: "warning",
                        width: 400,
                        formdata: [
                            {
                                label: "",
                                key: "pass",
                                tag: "vRadio",
                                span: 22,
                                labelWidth: 100,
                                default: true,
                                options: [
                                    {
                                        label: "审核通过",
                                        trueValue: true,
                                    },
                                    {
                                        label: "审核拒回",
                                        trueValue: false,
                                    },
                                ],
                            },
                            {
                                label: "备注",
                                key: "remark",
                                tag: "vTextarea",
                                span: 22,
                                labelWidth: 80,
                                required: false,
                            },
                        ],
                        ajaxRequest: HttpTransferPlanAudit,
                    };
                    break;
            }
        },
        importItem() {
            if (!this.formData.lineId)
                return this.$VMessage.error("请先选择项目");
            this.operate = {
                show: true,
                title: "导入明细",
                component: "compMutiUpload",
                showFooter: false,
                width: 450,
                props: {
                    action:
                        process.env.VUE_APP_APIURL_FBB +
                        "/api/v2/Transit/importOrder",
                    name: "multipartFile",
                    data: {
                        id: this.id || null,
                        lineId: this.formData.lineId,
                    },
                    // accept: this.formData.attachType === 'Other' ? '' : 'image/*,application/pdf',
                    download: () => {
                        this.handleWebfs(
                            process.env.VUE_APP_APIURL_FBB +
                                "/api/v2/Transit/itemTemplate",
                            "download"
                        );
                    },
                    formatter: (res) => {
                        return res.data;
                    },
                },
                on: {
                    "on-success": async (list) => {
                        if (!list || !list.length) return;
                        let skuIds = list.map((item) => {
                            return item.productId;
                        });
                        await this.handleSKUDetail(skuIds).then((skuList) => {
                            if (!skuList.length)
                                return this.$VMessage.error("暂无sku数据");
                            list.map((item) => {
                                let result = {
                                    ...item,
                                };
                                for (let i = 0; i < skuList.length; i++) {
                                    if (
                                        item.productId == skuList[i].productId
                                    ) {
                                        result = {
                                            ...item,
                                            ...skuList[i],
                                        };
                                        let hasSame = false;
                                        this.productList.map((item) => {
                                            if (
                                                item.productId ==
                                                result.productId
                                            ) {
                                                hasSame = true;
                                                item.qty =
                                                    parseInt(item.qty) +
                                                    parseInt(result.qty);
                                            }
                                        });
                                        if (!hasSame) {
                                            this.productList.push(result);
                                        } else {
                                            this.handleTotal(this.productList);
                                        }
                                        break;
                                    }
                                }
                            });
                        });
                        this.operate.show = false;
                    },
                    "on-cancel": () => {
                        this.operate.show = false;
                    },
                },
            };
        },
        clearAll() {
            if (!this.productList.length) return;
            this.operate = {
                show: true,
                title: "清空",
                alert: "error",
                ajaxRequest: async () => {
                    await HttpTransferPlanClear({
                        id: this.id,
                    }).then(
                        (res) => {
                            this.productList = [];
                            this.productData = {};
                            this.totalData = {};
                        },
                        (err) => {
                            this.$VMessage.error(err.message);
                        }
                    );
                },
            };
        },
        handleColumnsSelect(selection) {
            this.selectedData = selection;
        },
        handleAttachSelect(selectList) {
            this.selectedAttach = selectList;
        },
        async getDetail() {
            this.loading = true;
            await HttpGetDetail({
                id: this.id,
            }).then(
                async (res) => {
                    if (this.type !== "query") {
                        // 进页面会展示必填报错，先取消
                        await this.$nextTick(() => {
                            this.$refs.editform.resetValidate();
                        });
                    }
                    let {
                        itemEntities,
                        orderAttacheList,
                        orderLogList,
                        totalVolume,
                        totalWeight,
                        planQty,
                        ...formData
                    } = {
                        ...res.data,
                    };
                    this.productList = itemEntities || [];
                    let ids = this.productList.map((item) => {
                        return item.productId;
                    });
                    if (ids && ids.length) {
                        await this.handleSKUDetail(ids).then((skuList) => {
                            this.productList = this.productList.map((item) => {
                                let result = {
                                    ...item,
                                };
                                for (let i = 0; i < skuList.length; i++) {
                                    if (
                                        item.productId == skuList[i].productId
                                    ) {
                                        result = {
                                            ...result,
                                            ...skuList[i],
                                        };
                                        break;
                                    }
                                }
                                return result;
                            });
                        });
                    }
                    this.attachList = orderAttacheList || [];
                    this.logList = orderLogList || [];
                    this.totalData = {
                        totalVolume,
                        totalWeight,
                        planQty,
                    };
                    // this.formData = formData;
                    Object.keys(formData).map((key) => {
                        this.$set(this.formData, key, formData[key]);
                    });
                },
                (err) => {
                    this.$VMessage.error(err.message);
                }
            );
            this.isFirstGetData = false;
            this.loading = false;
        },
        async addOne() {
            let flag = true;
            await this.$refs.productForm.validate((valid) => {
                flag = valid;
            });
            if (!flag) return;
            let isAdd = this.type == "add";
            this.loading = true;
            await this.handleSKUDetail(this.skuData.id).then(
                async (skuList) => {
                    if (!skuList.length)
                        return this.$VMessage.error("暂无sku数据");
                    let data = {
                        sku: this.skuData.sku,
                        productId: this.skuData.id,
                        qty: this.productData.qty,
                        alias: this.productData.alias,
                        ...skuList[0],
                    };
                    // 添加时无id
                    if (isAdd) {
                        let hasSame = false;
                        this.productList.map((item) => {
                            if (item.productId == data.productId) {
                                item.qty =
                                    parseInt(item.qty) + parseInt(data.qty);
                                hasSame = true;
                            }
                        });
                        if (!hasSame) {
                            this.productList.push(data);
                        } else {
                            this.handleTotal(this.productList);
                        }
                        // 编辑
                    } else {
                        await HttpTransferPlanAddProduct({
                            id: this.id,
                            ...data,
                        }).then(
                            (res) => {
                                this.productList = res.data.map((item) => {
                                    return {
                                        ...item,
                                        ...skuList[0],
                                    };
                                });
                                this.handleTotal(this.productList);
                            },
                            (err) => {
                                this.$VMessage.error(err.message);
                            }
                        );
                    }
                }
            );
            this.loading = false;
            // this.productData = {};

            this.$refs.productForm.resetFields();
        },
        handleSKUDetail(ids) {
            return new Promise((resolve, reject) => {
                HttpFindSKU({
                    ids: ids,
                }).then(
                    (res) => {
                        let skuList = res.data.map((item) => {
                            let volumn = item.length * item.width * item.height;
                            return {
                                productId: item.id,
                                name: item.name,
                                weight: item.weight,
                                length: item.length,
                                width: item.width,
                                height: item.height,
                                volumn: volumn,
                                kgWeight: item.weight / 1000,
                                cbmVolumn: volumn / 1000000,
                            };
                        });
                        resolve(skuList);
                    },
                    (err) => {
                        this.$VMessage.error(err.message);
                    }
                );
            });
        },
        deleteOne() {
            if (!this.selectedData.length)
                return this.$VMessage.warning("请选择需要删除的项");
            let isAdd = this.type == "add";
            this.operate = {
                show: true,
                title: "删除",
                alert: "error",
                ajaxRequest: async () => {
                    let deleteIds = [];
                    this.selectedData.map((deleteItem) => {
                        if (isAdd) {
                            this.productList.map((item, index) => {
                                if (deleteItem.sku == item.sku) {
                                    this.productList.splice(index, 1);
                                }
                            });
                        } else {
                            deleteIds.push(deleteItem.id);
                        }
                    });
                    if (!deleteIds.length) {
                        return;
                    } else {
                        await HttpTransferPlanDeletById({
                            ids: deleteIds,
                        }).then(
                            (res) => {
                                this.selectedData.map((deleteItem) => {
                                    this.productList.map((item, index) => {
                                        if (deleteItem.sku == item.sku) {
                                            this.productList.splice(index, 1);
                                        }
                                    });
                                });
                            },
                            (err) => {
                                this.$VMessage.error(err.message);
                            }
                        );
                    }
                },
            };
        },
        addAttach() {
            this.operate = {
                show: true,
                title: "附件上传",
                component: "compAttach",
                showFooter: false,
                width: 460,
                props: {
                    id: this.id || 0,
                },
                on: {
                    "on-success": (data) => {
                        this.attachList.push(data);
                        this.operate.show = false;
                    },
                    "on-cancel": () => {
                        this.operate.show = false;
                    },
                },
            };
        },
        async deleteAttach() {
            if (!this.selectedAttach.length)
                return this.$VMessage.error("请选择需要删除的项");
            this.operate = {
                show: true,
                title: "删除附件",
                alert: "error",
                ajaxRequest: async () => {
                    let ids = this.selectedAttach.map((item) => {
                        return item.id;
                    });
                    await HttpDelAttach({
                        id: this.id,
                        attachmentIds: ids,
                    }).then(
                        (res) => {
                            this.$VMessage.success(res.message);
                            for (let i = 0; i < ids.length; i++) {
                                for (let j = 0; j < this.attachList.length; ) {
                                    if (ids[i] == this.attachList[j].id) {
                                        this.attachList.splice(j, 1);
                                        break;
                                    } else {
                                        j++;
                                    }
                                }
                            }
                        },
                        (err) => {
                            this.$VMessage.error(err.message);
                        }
                    );
                },
            };
        },
        handleSKU() {
            this.operate = {
                show: true,
                title: "查找SKU",
                component: "compSku",
                showFooter: false,
                width: 800,
                props: {
                    lineId: this.formData.lineId,
                },
                on: {
                    "on-select": (row) => {
                        this.$set(this.productData, "sku", row.sku);
                        this.productData.sku = row.sku;
                        this.skuData = row;
                    },
                    "on-close": () => {
                        this.operate.show = false;
                    },
                },
            };
        },
        async submit(type) {
            await this.$refs.editform.validate();
            let handleAjax = HttpUpdatePlan;
            // 保存并提交
            if (type == 1) {
                handleAjax = HttpSubmitUpdatePlan;
            }
            this.loading = true;
            await handleAjax({
                id: this.id,
                ...this.formData,
                transitPlanOrderItemModels: this.productList,
                orderAttachModelList: this.attachList,
            }).then(
                (res) => {
                    this.$VMessage.success(res.message);
                    this.$router.push({
                        name: "transferPlanList",
                    });
                },
                (err) => {
                    this.$VMessage.error(err.message);
                }
            );
            this.loading = false;
        },

        cancel() {
            if (this.activeid) {
                this.$emit("on-close");
            } else {
                this.$router.push({
                    name: "transferPlanList",
                });
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.button-container {
    margin-top: 15px;
    display: flex;
    justify-content: space-between;

    .left-button > * {
        margin-right: 15px;
    }
}
</style>
